<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Loader from "@/components/widgets/preloader";
    import { mapState,mapGetters,mapActions } from "vuex"
    import Swal from "sweetalert2";    
    
    /**
     * Advanced table component
     */
    export default {
      page: {
        title: "Pending Spoilt Stock",
        meta: [
          {
            name: "description",
            content: appConfig.description,
          },
        ],
      },
      components: {
        Layout,
        PageHeader,
        Loader,
      },
      data() {
        return {
          title: "Pending Spoilt Stock ",
          items: [
            {
              text: "Home",
              href: "/",
            },
            {
              text: "Pending Spoilt Stock",
              active: true,
            },
          ],
          totalRows: 1,
    
          currentPage: 1,
          perPage: 10,
          pageOptions: [10, 25, 50, 100, 200, 1000],
          filter: null,
          todoFilter: null,
          filterOn: [],
          todofilterOn: [],
          sortDesc: false,
          modal_id: "",
          fields: [
            {
              key: "index",
              sortable: true,
              label: "S/N",
            },
            {
              key: "date",
              sortable: true,
              label: "Date",
            },
            {
              key: "productname",
              sortable: true,
              label: "PRODUCT",
            },
    
            {
              key: "qty",
              sortable: true,
              label: "QTY",
            },
    
            {
              key: "buyingprice",
              sortable: true,
              label: "BUYING PRICE",
            },
    
            {
              key: "batch",
              sortable: true,
              label: "BATCH",
            },
            {
              key: "reason",
              sortable: true,
              label: "REASON",
            },
            {
              key: "user.name",
              sortable: true,
              label: "ADDED By",
            },
            // {
            //   key: "dateAdded",
            //   sortable: true,
            //   label: "DATE ADDED",
            // },
            {
              sortable: false,
              key: "actions",
              label: "ACTIONS",
            },
          ],
          fields1: [
            {
              key: "index",
              sortable: true,
              label: "S/N",
            },
            {
              key: "date",
              sortable: true,
              label: "Date",
            },
            {
              key: "productname",
              sortable: true,
              label: "PRODUCT",
            },
    
            {
              key: "qty",
              sortable: true,
              label: "QTY",
            },
    
            {
              key: "buyingprice",
              sortable: true,
              label: "BUYING PRICE",
            },
    
            {
              key: "batch",
              sortable: true,
              label: "BATCH",
            },
            {
              key: "reason",
              sortable: true,
              label: "REASON",
            },
            {
              key: "user.name",
              sortable: true,
              label: "ADDED By",
            },
            {
              key: "branch.name",
              sortable: true,
              label: "BRANCH",
            },
          ],
          FBatches: [],
          // delete unit
          deletedata: {
              name: "",
              id: "",
          },
          filterdata: {
              category: 2,
          },
          // Confirm spoilt product data
          confirmdata: {
            name: "",
            id: "",
          },
          //Reject Spoilt record
          rejectdata: {
              name: "",
              id: "",
          },
          resetDelete() {
            this.deletedata.name = "";
            this.deletedata.id = "";
            this.modal_id = "";
            },
          resetConfirm() {
            this.confirmdata.name = "";
            this.confirmdata.id = "";
            this.modal_id = "";
          },
          resetReject() {
            this.rejectdata.name = "";
            this.rejectdata.id = "";
            this.modal_id = "";
          },
          //== close modal
          closeModal(modalId) {
            this.$nextTick(() => {
                this.$bvModal.hide(modalId);
            });
          },
        };
      },
      computed: {
        // MAP STATE
        ...mapState("notification", [
          "type",
          "message",
          "show",
        ]),
        ...mapGetters("stock", ["SaveStatus", "PendingSpoilt"]),
        ...mapGetters("products", ["Products","Batches"]),
        ...mapGetters('auth',["MyUserPerm","branchid","Branches"]),
    
        /**
         * Total no. of records
         */
    
        rows() {
          return this.PendingSpoilt ? this.PendingSpoilt.length : 1;
        },
    
        /**
         * Todo list of records
         */
      },
      mounted() {
        // Set the initial number of items
        this.totalRows = this.PendingSpoilt ? this.PendingSpoilt.length : 1;
      },
      watch: {
        show(newValue) {
          // Do whatever makes sense now
          if (newValue == true) {
            this.closeModal(this.modal_id);
            if (this.type == "success") {
              Swal.fire("Success!", this.message.msg, "success");
              // this.$toast.success(this.message.msg);
            } else {
              // this.$toast.error(this.message.msg);
              Swal.fire("Error!", this.message.msg, "error");
            }
          }
        },
      },
      methods: {
        ...mapActions({
          FetchProducts: "products/fetchProducts",
          FetchBatches: "products/fetchBatches",
          FetchPendingSpoilt: "stock/fetchPendingSpoilt",
          DeleteSpoilt: "stock/deleteSpoilt",
          ConfirmSpoiltStock: "stock/ConfirmSpoilt",
          RejectSpoiltStock: "stock/RejectSpoilt",
        }),
        /**
         * Search the table data with search input
         */
        onFiltered(filteredItems) {
          // Trigger pagination to update the number of buttons/pages due to filtering
          this.totalRows = filteredItems.length;
          this.currentPage = 1;
        },

        // Confirm Spoilt stock
        confirmSpoilt(modalId) {
            this.modal_id = modalId;
            this.ConfirmSpoiltStock(this.confirmdata);
        },

        showConfirmModal(data) {
          this.confirmdata.name = data.item.product.product_name;
          this.confirmdata.id = data.item.id;
        },

        // Reject Spoilt stock
        rejectSpoilt(modalId) {
            this.modal_id = modalId;
            this.RejectSpoiltStock(this.rejectdata);
        },

        showRejectModal(data) {
        this.rejectdata.name = data.item.product.product_name;
        this.rejectdata.id = data.item.id;
        },

      },
      created() {
        this.FetchPendingSpoilt(this.filterdata);
        this.FetchProducts();
        this.FetchBatches();
      },
    };
    </script>
    
    <template>
      <Layout>
        <PageHeader :title="title" :items="items" />
    
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-9">
                    <h4 class="card-title">Pending Spoilt Stock</h4>
                  </div>
                  <div class="col-md-3" align="right">
                    <router-link :to="'/consumables/spoilt'">
                    <b-button variant="primary">Confirmed Spoilt</b-button>
                    </router-link>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                            class="form-select form-select-sm"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ms-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <b-table
                      class="datatables"
                      :items="PendingSpoilt?PendingSpoilt:[]"
                      :fields="branchid==0?fields1:fields"
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      @filtered="onFiltered"
                  >
                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template>
    
                    <template #cell(actions)="data">
    <!--                  <b-button-->
    <!--                      size="sm"-->
    <!--                      variant="primary"-->
    <!--                      v-b-modal.edit-product-modal-->
    <!--                      class="m-2"-->
    <!--                      @click="showEditModal(data)"-->
    <!--                  ><i class="fa fa-edit"></i></b-button-->
    <!--                  >-->
                      <b-button v-if="data.item.expired!=1 && MyUserPerm.delete_spoilt_consumables == 1"
                          size="sm"
                          variant="danger"
                          v-b-modal.delete-product-modal
                          @click="showDeleteModal(data)"
                      ><i class="fa fa-trash"></i></b-button
                      >
                      <b-button v-if="MyUserPerm.confirm_spoilt_consumables == 1"
                          size="sm"
                          variant="warning"
                          v-b-modal.spoilt-product-modal
                          @click="showConfirmModal(data)"
                      ><i class="fa fa-check"></i>Confirm</b-button
                      >
                      <b-button v-if="MyUserPerm.confirm_spoilt_consumables == 1"
                          size="sm"
                          variant="danger"
                          v-b-modal.rejectspoilt-product-modal
                          @click="showRejectModal(data)"
                      ><i class="fa fa-trash"></i>Reject</b-button
                      >
                    </template>
                  </b-table>
                </div>
                <Loader  v-if="!PendingSpoilt"/>
                <div class="row">
                  <div class="col">
                    <div
                        class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    
        <!-- modal confirm spoilt starts -->
        <b-modal
            header-bg-variant="danger"
            header-text-variant="light"
            body-text-variant="danger"
            footer-bg-variant="danger"
            footer-text-variant="danger"
            id="rejectspoilt-product-modal"
            hide-footer
            @hidden="resetConfirm"
        >
          <template #modal-title> Reject Spoilt Product {{ rejectdata.name }}</template>
          <div class="form-group mb-3">
            <div class="input-group">
              <h5>
                Do you want to reject this spoilt stock record? Click Proceed Button to confirm.
              </h5>
            </div>
          </div>
          <div class="modal-footer">
            <button
                type="button"
                class="btn btn-warning"
                data-dismiss="modal"
                @click="closeModal('rejectspoilt-product-modal')"
            >
              <i class="fa fa-times"></i> Close
            </button>
            <button
                type="button"
                class="btn btn-danger"
                @click="rejectSpoilt('rejectspoilt-product-modal')"
            >
              <i class="fa fa-trash"></i> Proceed
              <b-spinner
                  v-if="SaveStatus"
                  variant="light"
                  small
                  label="Rejecting"
              ></b-spinner>
            </button>
          </div>
        </b-modal>
        <!-- modal ends -->
    
        <!-- modal confirm spoilt starts -->
        <b-modal
            header-bg-variant="warning"
            header-text-variant="light"
            body-text-variant="warning"
            footer-bg-variant="warning"
            footer-text-variant="warning"
            id="spoilt-product-modal"
            hide-footer
            @hidden="resetConfirm"
        >
          <template #modal-title> Confirm Spoilt Product {{ confirmdata.name }}</template>
          <div class="form-group mb-3">
            <div class="input-group">
              <h5>
                Do you want to confirm this spoilt stock record? Click Proceed Button to confirm.
              </h5>
            </div>
          </div>
          <div class="modal-footer">
            <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
                @click="closeModal('spoilt-product-modal')"
            >
              <i class="fa fa-times"></i> Close
            </button>
            <button
                type="button"
                class="btn btn-warning"
                @click="confirmSpoilt('spoilt-product-modal')"
            >
              <i class="fa fa-trash"></i> Proceed
              <b-spinner
                  v-if="SaveStatus"
                  variant="light"
                  small
                  label="Confirming"
              ></b-spinner>
            </button>
          </div>
        </b-modal>
        <!-- modal ends -->
      </Layout>
    </template>
    
    <style>
    .btn-primary { background-color:#FAB031 !important;border-color:#FAB031 !important;}
    </style>
    